export const zoomForms = {
  standup: 'https://zoom.us/webinar/register/WN_Sh2acAKZQZ-bdKFWpuJVwQ',
};
